<div
    class="layers-container"
    [ngStyle]="{
        height: groupElementId ? '100%' : 'calc(100% - 44px)',
    }">
    <div *ngFor="let layer of currentLayers; index as i" class="layer-wrapper">
        <div
            class="layer-row-wrapper"
            (click)="selectLayer(layer)"
            [ngClass]="{ selectedElement: layer.id == selectedLayer?.id }">
            <div class="layer-item">
                <mat-icon [svgIcon]="getMatIcon(layer)" class="layer-icon" />
                <div class="layer-name">{{ getLayerName(layer) }}</div>
                <mat-icon
                    *ngIf="isGroup(layer)"
                    svgIcon="arrow-down"
                    class="layer-icon"
                    [ngStyle]="{
                        transform: shouldShowElements(layer) ? 'rotate(180deg)' : '',
                    }" />
            </div>

            <div class="options-container" #otherOptions>
                <mat-icon
                    svgIcon="more-options"
                    class="icon"
                    [class.selected]="visibleOptions == i"
                    (click)="openOptions(i, layer); $event.stopPropagation()" />
            </div>
        </div>
        <ng-container *ngIf="shouldShowElements(layer)">
            <app-layers-menu class="group-elements" [groupElementId]="layer.id"></app-layers-menu>
        </ng-container>
    </div>
</div>
